import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import './App.css';
import Navbar from './Navbar'
import HomeContainer from "./Home/HomeContainer";
import AboutMe from "./AboutMe/AboutMe";
import Experience from "./Experience/Experience"
import ProjectContainer from "./Project/ProjectContainer";
import Skills from "./Skills/Skills";
import BreadIsGold from "./Project/BreadIsGold";
import BurgerDiner from "./Project/BurgerDiner";
import AllensCabinets from "./Project/AllensCabinets";
import GenesisMassage from "./Project/GenesisMassage";
import Contact from "./Contact/Contact";


function App() {
  return (
    <div className="App" >
      <Navbar/>

      <Switch>
        <Route exact path='/' component={HomeContainer} />
        <Route exact path='/aboutme' component={AboutMe} />
        <Route exact path='/experience' component={Experience} />
        <Route exact path='/project' component={ProjectContainer} />
        <Route exact path='/skills' component={Skills} />
         <Route exact path='/contact' component={Contact} />

        <Route exact path='/project/breadisgold' component={BreadIsGold} />
        <Route exact path='/project/burgerdiner' component={BurgerDiner} />
        <Route exact path='/project/allenscabinets' component={AllensCabinets} />
        <Route exact path='/project/genesismassage' component={GenesisMassage} />
      </Switch>
    </div>
  );
}

export default App;
